import { Checkbox, type CheckboxProps, type SxProps, type Theme } from '@mui/material'
import React, { type FC } from 'react'

const checkboxStyle: SxProps<Theme> = { p: 0, color: '#DADADA' }

export const TableCheckbox: FC<CheckboxProps> = (props) => <Checkbox {...props} sx={checkboxStyle} size="small" />
